module.exports = __webpack_public_path__ + "img/hips.ede96f44.png";